import { createAsyncThunk } from "@reduxjs/toolkit";

import { EndPoints } from "../../api/endpoints";
import axiosClient from "../../api/axiosClient";
import { FilterQueryParams } from "../../forms/FilterForm";
import { User } from "../apiSlice/userSlice";

export const getUser = createAsyncThunk(
  "getUser",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.user);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const getAtcUsers = createAsyncThunk(
  "getAtcUsers",
  async (atc_id: string, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(`${EndPoints.usersAtc}/${atc_id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const deleteUser = createAsyncThunk(
  "deleteUser",
  async (id: string, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.delete(`${EndPoints.user}/${id}`);
      dispatch(getUser());
      return { status: response.data.status, id };
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const createUser = createAsyncThunk(
  "createUser",
  async (data: User, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.put(`${EndPoints.user}`, data);
      dispatch(getUser());
      return { status: response.data.status };
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const updateUser = createAsyncThunk(
  "updateUser",
  async (
    { data, popup }: { data: User; popup: any },
    { dispatch, rejectWithValue }
  ): Promise<any> => {
    try {
      const response = await axiosClient.patch(`${EndPoints.user}`, data);
      dispatch(getUser());
      popup.close();
      return { status: response.data.status };
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const updateAtcUser = createAsyncThunk(
  "updateAtcUser",
  async (
    {
      data,
      popup,
      user_id,
      atc_id,
    }: { data: User; popup: any; user_id: string; atc_id: string },
    { dispatch, rejectWithValue }
  ): Promise<any> => {
    try {
      const response = await axiosClient.patch(
        `${EndPoints.usersAtc}/${atc_id}/user/${user_id}`,
        data
      );
      dispatch(getAtcUsers(atc_id));
      popup.close();
      return { status: response.data.status };
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const filterUser = createAsyncThunk(
  "filterUser",
  async (queryParams: FilterQueryParams, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(
        `${EndPoints.user}/filter/?from=${queryParams.from}&to=${queryParams.to}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const filterAtcUser = createAsyncThunk(
  "filterAtcUser",
  async (
    { queryParams, atc_id }: { queryParams: FilterQueryParams; atc_id: string },
    { rejectWithValue }
  ): Promise<any> => {
    try {
      const response = await axiosClient.get(
        `${EndPoints.user}/atc/${atc_id}/filter/?from=${queryParams.from}&to=${queryParams.to}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);
